import { __generator } from "tslib";
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { select, takeLatest, call } from 'redux-saga/effects';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { loadDuperbrowseItem } from '../../Duperbrowse/redux/actionCreators';
import { getLoadCount } from '../../Duperbrowse/redux/selectors';
import { getDuperRedirectThreshold } from './selectors';
var logger = ddt.createLogger('sisufunnel');
function handleLoading(_a) {
    var loadCount, threshold, data;
    var itemSchema = _a.payload.itemSchema;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (itemSchema !== 'deviation') {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getLoadCount)];
            case 1:
                loadCount = _b.sent();
                logger.log('Duperbrowse load count: ', loadCount);
                return [4 /*yield*/, select(getDuperRedirectThreshold)];
            case 2:
                threshold = _b.sent();
                // Noop because BI still looking into signup data
                if (1 === 1) {
                    return [2 /*return*/];
                }
                if (!(loadCount > threshold)) return [3 /*break*/, 4];
                data = {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.SISU_FUNNEL_NEXT_DEVIATION,
                };
                return [4 /*yield*/, call(logBiEvent, data)];
            case 3:
                _b.sent();
                window.location.assign(Url.joinLink());
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export function sisuFunnelSaga() {
    var loggedIn;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                loggedIn = _a.sent();
                if (loggedIn) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, takeLatest(loadDuperbrowseItem, handleLoading)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map